import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
    position: absolute;
    stroke: #525b75;
    pointer-events: none;

    &.search-icon {
      left: 12px;
    }

    &.close-icon {
      transition: opacity 0.25s ease;
      right: 12px;
      cursor: pointer;
      opacity: 0;

      &.visible {
        pointer-events: all;
        opacity: 1;
      }
    }
  }
`

export const StyledInput = styled.input<{
  fluid?: boolean
}>`
  ${({ fluid }) => css`
    transition: outline 0.1s ease;
    height: 37px;
    width: ${fluid ? '100%' : 'auto'};
    border: 1px solid #e6e8eb;
    border-radius: 4px;
    font-size: 14px;
    padding-left: 40px !important;
    padding-right: 40px !important;
    outline: 1px solid transparent;

    &::placeholder {
      color: #a1a5b0;
    }

    &:focus {
      outline: 1px solid #a1a5b0;
    }
  `}
`
